module.exports = __webpack_public_path__ + "img/a01.96029a63.svg";